import React from 'react';
import Link from 'next/link';
import { Grid, Typography, Button, Box } from '@mui/material';
import Image from 'next/image';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ScrollAnimation from './ScrollAnimation';

const ContentSection = ({ title, description, buttonText, imageSrc, imageAlt, imageFirst }) => {
  const textSection = (
    <Grid item xs={12} md={6} sx={{ textAlign: 'left', px: 5 }}>
      <Box sx={{ pl: imageFirst ? '80px' : '0px' }}>
        <Typography variant="h3" gutterBottom sx={{ color: 'white', letterSpacing: '-1px', fontWeight: 700, mt: '30px', mb: 0, fontSize: '34px', lineHeight: '120%', textAlign: 'left' }}>
          {title}
        </Typography>
        <Typography variant="h5" gutterBottom sx={{ color: 'white', mt: '20px', mb: 0, fontSize: '16px', fontWeight: 400, lineHeight: '160%', textAlign: 'left' }}>
          {description}
        </Typography>


        <Link href="/app/login" underline="none" hover="none">
          <Button variant="outlined" sx={{
            color: '#f06f96',
            fontSize: '18px',
            border: 'solid 2px #f06f96',
            fontWeight: 400,
            ineHeight: '160%',
            textAlign: 'left',
            textTransform: 'none',
            mt: 4,
            '&:hover': { background: '#f06f96', color: 'white', border: 'solid 2px #f06f96' }
          }}>
            <Typography variant="title-md">{buttonText}</Typography>
            <ArrowForwardIcon sx={{ ml: 1 }} />
          </Button>
        </Link>

      </Box>
    </Grid>
  );

  const imageSection = (
    <Grid item xs={12} md={6}>
      <Box sx={{ textAlign: imageFirst ? 'left' : 'right', pl: imageFirst ? '0' : '60px', pr: imageFirst ? '60px !important' : '0' }}>
        <Image src={imageSrc} alt={imageAlt} width={571} height={462} priority
          style={{
            width: '100%',
            height: 'auto',
            maxHeight: '462px',
            objectFit: 'contain',
            borderRadius: '10px',
            boxShadow: 'rgb(255 35 171) 0px 0px 10px 2px'
          }} />
      </Box>
    </Grid>
  );

  return (
    <ScrollAnimation animateIn="fadeInUp" delay={0.2}>
      <Grid container spacing={2} sx={{ mt: 5, alignItems: 'center' }}>
        {imageFirst ? imageSection : textSection}
        {imageFirst ? textSection : imageSection}
      </Grid>
    </ScrollAnimation>
  );
};

export default ContentSection;
